import { getJson } from 'utils/http';

export type BackgroundTask<T> = {
  url: string;
  status: 'NOTHING_YET' | 'PENDING' | 'COMPLETED';
  result: T | null | undefined;
};
export const waitTaskCompleted = <T>(
  task: BackgroundTask<T>,
  timeout = 240000
): Promise<T> =>
  new Promise((resolve, reject) => {
    const WAIT_MS = 500;

    const checkTask = () => {
      getJson(task.url)
        .then(({ task: updatedTask }) => {
          if (updatedTask.status === 'COMPLETED') {
            resolve(updatedTask.result);
          } else {
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line no-param-reassign
            timeout -= WAIT_MS;

            if (timeout < 0) {
              reject(new Error('Request timed out'));
            } else {
              setTimeout(checkTask, WAIT_MS);
            }
          }
        })
        .catch(() => {
          reject(new Error('Request failed'));
        });
    };

    checkTask();
  });
